/* eslint-env browser, es6 */
import m from "mithril";

import { Duel, DuelResult } from "../api";
import { Board } from "../board";
import { getMissedWords } from "../game-controller";
import { GAME, GameStateDuelResults, initialState } from "../game-state";
import { FinishedBoardView } from "./board";
import { ButtonView } from "./button";
import { CopyPasteView } from "./copy-paste";
import { DuelResultsView } from "./duel-results";
import { FooterView, HeaderView } from "./header-footer";
import { ScoreMessageView } from "./messages";
import { WordListView } from "./word-list";
import { MissedWordsView } from "./missed-words";
import { getPersistentNicknameForDuel } from "../persistent-nickname";
import { scoreWordBase } from "../scoring";

interface GameDuelResultsViewAttrs {
  state: GameStateDuelResults;
}

export class GameDuelResultsView
  implements m.Component<GameDuelResultsViewAttrs> {
  private state: GameStateDuelResults;

  constructor(vnode: m.Vnode<GameDuelResultsViewAttrs>) {
    this.state = vnode.attrs.state;
  }

  view(): m.Children {
    const nickname = getPersistentNicknameForDuel(this.state.duel.duelId);
    const result = findResultForNickname(this.state.duel, nickname)!;

    // TODO(2024-12-08): This logic was added in a hurry. It duplicates a lot
    // of code elsewhere, especially in game-finished.ts. Should try to reuse
    // the same code.
    const board = new Board(this.state.duel.boardLetters);
    const missedWords = getMissedWords(new Set(result.words), board);
    let maxScore = 0;

    const wordsWithScores: [string, number][] = [];
    for (const word of result.words) {
      const thisScore = scoreWordBase(word);
      maxScore += thisScore;
      wordsWithScores.push([word, thisScore]);
    }

    for (const word of missedWords) {
      maxScore += scoreWordBase(word);
    }

    return [
      m(HeaderView),
      m(FinishedBoardView, { board }),
      m(ButtonView, {
        message: "New game",
        hookOnClick: () => {
          GAME.state = initialState();
          m.route.set("/webble");
        },
      }),
      m(ScoreMessageView, { score: result.score, maxScore }),
      m(DuelResultsView, { duel: this.state.duel, nickname }),
      m(CopyPasteView, { duelId: this.state.duel.duelId }),
      m(WordListView, { wordList: wordsWithScores }),
      m(MissedWordsView, { missedWords: missedWords }),
      m(FooterView),
    ];
  }
}

function findResultForNickname(duel: Duel, nickname: string): DuelResult | null {
  for (const result of duel.results) {
    if (nickname === result.nickname) {
      return result;
    }
  }

  return null;
}
